class ProductAddonsCustom extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return
    this.initialized = true
    this.quantities = new Map()
    this.addEventListener('click', (event) => {
      const form = this.closest('variant-selects-custom')?.querySelector('product-form-custom')
      if (form?.submitting || form?.cartNeedsReview) return
      const button = event.target.closest('[data-addon-add], [data-addon-remove]')
      if (!button || button.disabled) return
      const tile = button.closest('[data-addon]')
      const before = this.quantities.get(tile.dataset.id) || 0
      const delta = button.hasAttribute('data-addon-remove') ? -1 : 1
      const quantity = Math.max(0, Math.min(Number(tile.dataset.limit), before + delta))
      this.quantities.set(tile.dataset.id, quantity)
      const badge = tile.querySelector('[data-addon-count]')
      badge.textContent = quantity
      badge.hidden = quantity === 0
      tile.classList.toggle('is-selected', quantity > 0)
      tile.querySelector('[data-addon-add]').disabled = quantity >= Number(tile.dataset.limit)
      const removeButton = tile.querySelector('[data-addon-remove]')
      removeButton.hidden = quantity === 0
      removeButton.disabled = quantity === 0
      this.querySelector('[data-addon-status]').textContent = `${tile.dataset.label}: ${quantity} selected.`
      this.closest('variant-selects-custom').querySelector('product-form-custom')?.updateSubTotal()
    })
  }

  get totalCents() {
    return [...this.querySelectorAll('[data-addon]')].reduce(
      (total, tile) => total + Number(tile.dataset.priceCents) * (this.quantities?.get(tile.dataset.id) || 0),
      0,
    )
  }

  // Shopify's native parent relationship removes these lines when their tree is removed.
  getItems(parentId, groupId, baseHandle) {
    return [...this.querySelectorAll('[data-addon]')].flatMap((tile) => {
      const quantity = this.quantities?.get(tile.dataset.id) || 0
      if (!quantity) return []
      if (tile.dataset.id === String(parentId)) throw new Error('An accessory cannot be its own parent.')
      return [
        {
          id: Number(tile.dataset.id),
          quantity,
          parent_id: Number(parentId),
          properties: { '_Tree Configuration': groupId, '_Base Product Handle': baseHandle },
        },
      ]
    })
  }
}
if (!customElements.get('product-addons-custom')) customElements.define('product-addons-custom', ProductAddonsCustom)
